/**
 * Parses a ParallaxLayer: the Node2D surface plus the `motion_*` group.
 * `motion_mirroring` clamps at 0 per axis, as `ParallaxLayer::set_mirroring`'s
 * `p_mirroring.maxf(0)` does, so Godot never stores a negative interval.
 */
import { vec2Or } from '../../../parser/valueParsers';
import { parseNode2D } from '../../base/node2d/parser';
export function parseParallaxLayer(heading, properties) {
    const base = parseNode2D(heading, properties);
    const context = base.name || 'ParallaxLayer';
    const mirroring = vec2Or(properties.motion_mirroring, { x: 0, y: 0 }, context);
    return {
        ...base,
        motion_scale: vec2Or(properties.motion_scale, { x: 1, y: 1 }, context),
        motion_offset: vec2Or(properties.motion_offset, { x: 0, y: 0 }, context),
        motion_mirroring: { x: Math.max(0, mirroring.x), y: Math.max(0, mirroring.y) },
    };
}
//# sourceMappingURL=parser.js.map